import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=b6dcd4bc&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=b6dcd4bc&prod&lang=css"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=b6dcd4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dcd4bc",
  null
  
)

export default component.exports